export default __webpack_public_path__ + "static/media/shape1.1bb8a7a6.svg";